import { tr } from "../../i18n";
import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import AuthLayout, { Field, ErrorNote, inputCls } from "./AuthLayout";
import { api, apiError } from "../../auth/AuthContext";
export default function ResetPassword() {
  const {
    lang = "en"
  } = useParams();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        token,
        password,
        confirm_password: confirm
      });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title={tr("Reset Password")} subtitle={done ? undefined : "Choose a new password for your ESAIA account."}>
      {done ? <div data-testid="reset-success">
          <p className="border border-emerald-600/30 bg-emerald-50 p-4 text-sm text-emerald-800">{tr("Your password has been updated successfully.")}{" "}</p>
          <Link to={`/${lang}/login`} className="mt-6 block w-full bg-esaia-blue px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-esaia-dark" data-testid="return-to-login">{tr("Return to Login")}{" "}</Link>
        </div> : <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <ErrorNote error={error} />
          {!token && <p className="border border-amber-600/30 bg-amber-50 px-4 py-3 text-sm text-amber-800">{tr("This reset link is missing its token. Please use the link from your email.")}{" "}</p>}
          <Field label={tr("New password")} required htmlFor="reset-pass">
            <input id="reset-pass" type="password" required value={password} onChange={e => setPassword(e.target.value)} className={inputCls} data-testid="reset-password-input" autoComplete="new-password" />
          </Field>
          <Field label={tr("Confirm new password")} required htmlFor="reset-pass2">
            <input id="reset-pass2" type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} className={inputCls} data-testid="reset-confirm-input" autoComplete="new-password" />
          </Field>
          <button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="w-full bg-esaia-blue px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
            {loading ? tr("Updating...") : tr("Reset Password")}
          </button>
        </form>}
    </AuthLayout>;
}
